import { NodeData, ExtendedNetworkDefinition, NetworkType, DashboardNetworkType, convertNetworkTypeToDashboard } from './NetworkTypes';

// Import mockNetworks data directly to avoid circular dependencies
import { mockNetworks } from '@/data/mockNetworks';

export const generateNodeData = (timePoints: number): NodeData[] => {
  const nodes: NodeData[] = [];
  
  mockNetworks.forEach((network: ExtendedNetworkDefinition, netIndex: number) => {
    if (network.status === 'active' || network.status === 'maintenance') {
      const gateway: NodeData = {
        id: `${network.id}-gateway`,
        name: `${network.name} Gateway`,
        type: 'gateway',
        network: network.type,
        data: Array.from({ length: timePoints }, (_, i) => ({
          time: `${i}:00`,
          value: Math.max(40, Math.min(100, network.metrics.signalStrength + Math.floor(Math.random() * 10) - 5))
        }))
      };
      nodes.push(gateway);
      
      const relayCount = 1 + Math.floor(Math.random() * 2);
      for (let i = 0; i < relayCount; i++) {
        const relay: NodeData = {
          id: `${network.id}-relay-${i}`,
          name: `${network.name} Relay ${i + 1}`,
          type: 'relay',
          network: network.type,
          data: Array.from({ length: timePoints }, (_, j) => ({
            time: `${j}:00`,
            value: Math.max(30, Math.min(90, network.metrics.signalStrength - 10 + Math.floor(Math.random() * 20) - 10))
          }))
        };
        nodes.push(relay);
      }
      
      const endpointCount = 2 + Math.floor(Math.random() * 2);
      for (let i = 0; i < endpointCount; i++) {
        const endpoint: NodeData = {
          id: `${network.id}-endpoint-${i}`,
          name: `${network.name} Endpoint ${i + 1}`,
          type: 'endpoint',
          network: network.type,
          data: Array.from({ length: timePoints }, (_, j) => ({
            time: `${j}:00`,
            value: Math.max(20, Math.min(80, network.metrics.signalStrength - 20 + Math.floor(Math.random() * 20) - 10))
          }))
        };
        nodes.push(endpoint);
      }
    }
  });
  
  return nodes;
};

export const prepareChartData = (nodes: NodeData[]) => {
  if (!nodes.length) return [];
  
  const timePoints = nodes[0].data.map(d => d.time);
  return timePoints.map((time, index) => {
    const dataPoint = { time };
    nodes.forEach(node => {
      dataPoint[node.id] = node.data[index].value;
    });
    return dataPoint;
  });
};

export const createAnimatedLineStyle = () => {
  return {
    animation: 'flow 3s linear infinite'
  };
};
